import { Typography } from '@mui/material';

import React from 'react';

export interface SlideSubtitleProps {
  readonly children: React.ReactNode;
  style?: React.CSSProperties;
}

export function SlideSubtitle({
  children,
  style,
}: SlideSubtitleProps): React.ReactElement {
  return (
    <Typography
      component="h2"
      sx={{
        color: '#004F7E',
        fontFamily: 'Roboto',
        fontWeight: '600',
        fontSize: '26px',
        ...style,
      }}
    >
      {children}
    </Typography>
  );
}
